const ptPT = {
    crossmintPayButtonService: {
        CONNECTING: "A conectar...",
        BUY: "Comprar com Crossmint",
        BUY_WITH_ETH: "Comprar com ETH",
        BUY_WITH_SOL: "Comprar com SOL",
        BUY_WITH_CREDIT_CARD: "Comprar com cartão de crédito",
    },
};
export default ptPT;
